import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { COUNTRIES, NUMBER_PATTERN, ShipmentTransportMode, TransportMode } from '../../../../../common/constants';
import {
  Base,
  CombinedDatepickerRangeModel,
  CombinedDatepickerRangeOutput,
  DatepickerRangeModel,
  DatepickerRangeOutput,
} from '../../../../../common/models';
import { ShipmentDeviationType, DeviationType } from '../../../../models';
import { ListViewMode } from '../../constants';
import { DeliveryService, Origin, ShipmentOrigin } from '../../transport/constants/transport-list.constant';
import { DraggableFilterType, ShipmentMonitoringStatus } from '../../../../constants';
import { ShipmentFilterName } from '../constants';
import {
  ShipmentListFiltersETASources,
  ShipmentListFiltersRegions,
  ShipmentListFiltersServiceCode,
  ShipmentCriticalTransitStatuses,
  ShipmentCriticalTransitLocations,
} from '../../models';
import {
  MonitoringFilterGateOption,
  MonitoringFilterPlantOption,
} from '../../models/monitoring-filter-plant-option.model';
import { assignObjectIfPropertyValueValid } from '../../../../../common';
import { PartnerRegion } from '../../../administration/partner/constants/partner-region.constant';

export enum StatisticFilterKeysEnum {
  Milestone = 'milestone',
  Deviation = 'deviation',
  Info = 'info',
}

export enum IsSapActiveFilterValue {
  Yes = 'Yes',
  No = 'No',
}

export const SHIPMENT_FILTER_TYPE_BY_NAME: Map<ShipmentFilterName, DraggableFilterType> = new Map([
  [ShipmentFilterName.TransportOrderNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapPlantIds, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapSupplierNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapSupplierNames, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapMrpControllers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapMaterialNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapDeliveryNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapPoNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapExternalDeliveryNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.EquipmentIds, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.LoadNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.MaterialNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.DeliveryNoteNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.IStarNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.TransportModes, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.Origins, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.Statuses, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.DeliveryServices, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.DeviationTypes, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.DeviationHours, DraggableFilterType.Input],
  [ShipmentFilterName.BusinessUnits, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.MRPControllers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.Carriers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.Pickups, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.ShipTos, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.Consignees, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.ReasonCodes, DraggableFilterType.ChipsInputPopup],
  [ShipmentFilterName.StatusCodes, DraggableFilterType.ChipsInputPopup],
  [ShipmentFilterName.CarrierTOs, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.CommercialInvoiceNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.PurchaseOrderNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.TruckPlates, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.TrailerPlates, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.FlightNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.VesselNames, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.Waybills, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.References, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.InboundPlants, DraggableFilterType.ChipsInputSearch],
  [ShipmentFilterName.ShipToPlants, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.ConsigneePlants, DraggableFilterType.ChipsInputSearchGeneric],
  [ShipmentFilterName.EstimatedDepartureTimeLoad, DraggableFilterType.RangeDatepicker],
  [ShipmentFilterName.EstimatedDepartureTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
  [ShipmentFilterName.ActualDepartureTimeLoad, DraggableFilterType.RangeDatepicker],
  [ShipmentFilterName.ActualDepartureTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
  [ShipmentFilterName.PlannedDepartureTimeLoad, DraggableFilterType.RangeDatepicker],
  [ShipmentFilterName.PlannedDepartureTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
  [ShipmentFilterName.ArrivalTime, DraggableFilterType.CombinedRangeDatepicker],
  [ShipmentFilterName.DepartureTime, DraggableFilterType.CombinedRangeDatepicker],
  [ShipmentFilterName.InboundRegions, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.OutboundRegions, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.NetworkParts, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.ConsignorAddresses, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.FreightPayers, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.ContractIdentifiers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.RbPoNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.UnNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.RouteIds, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.BarcodeIds, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.BoschOrderNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.CustomerOrderNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.BoschMaterialNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.CustomerMaterialNumbers, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.SapIds, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.HUIds, DraggableFilterType.ChipsInput],
  [ShipmentFilterName.ServiceTypes, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.SecondaryEtaSources, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.SourceCountries, DraggableFilterType.MultipleDropDownSearchSelect],
  [ShipmentFilterName.DestinationCountries, DraggableFilterType.MultipleDropDownSearchSelect],
  [ShipmentFilterName.SourceLocations, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.DestinationLocations, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.PortsOfLoading, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.PortsOfDischarge, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.PortsOfLoadingCountries, DraggableFilterType.MultipleDropDownSearchSelect],
  [ShipmentFilterName.PortsOfDischargeCountries, DraggableFilterType.MultipleDropDownSearchSelect],
  [ShipmentFilterName.PortsOfLoadingRegions, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.PortsOfDischargeRegions, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.EtaTransferInSap, DraggableFilterType.DropDownSelect],
  [ShipmentFilterName.EtaUpdateInSap, DraggableFilterType.DropDownSelect],
  [ShipmentFilterName.SapSystems, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  [ShipmentFilterName.CriticalTransitLocations, DraggableFilterType.MultipleSelect],
  [ShipmentFilterName.CriticalTransitStatuses, DraggableFilterType.MultipleSelect],
]);

export const SHIPMENT_FILTER_SELECT_OPTIONS_BY_NAME = new Map<ShipmentFilterName, string[] | Base[]>([
  [ShipmentFilterName.TransportModes, Object.values(ShipmentTransportMode)],
  [ShipmentFilterName.Statuses, Object.values(ShipmentMonitoringStatus)],
  [ShipmentFilterName.DeliveryServices, Object.values(DeliveryService)],
  [
    ShipmentFilterName.Origins,
    Object.values(ShipmentOrigin).filter((origin: ShipmentOrigin) => origin !== ShipmentOrigin.EdiManager),
  ],
  [ShipmentFilterName.DeviationTypes, Object.values(ShipmentDeviationType)],
  [ShipmentFilterName.InboundRegions, Object.values(ShipmentListFiltersRegions)],
  [ShipmentFilterName.OutboundRegions, Object.values(ShipmentListFiltersRegions)],
  [ShipmentFilterName.ServiceTypes, Object.values(ShipmentListFiltersServiceCode)],
  [ShipmentFilterName.SecondaryEtaSources, Object.values(ShipmentListFiltersETASources)],
  [ShipmentFilterName.SourceCountries, COUNTRIES],
  [ShipmentFilterName.DestinationCountries, COUNTRIES],
  [ShipmentFilterName.PortsOfLoadingCountries, COUNTRIES],
  [ShipmentFilterName.PortsOfDischargeCountries, COUNTRIES],
  [ShipmentFilterName.PortsOfLoadingRegions, Object.values(PartnerRegion)],
  [ShipmentFilterName.PortsOfDischargeRegions, Object.values(PartnerRegion)],
  [ShipmentFilterName.EtaTransferInSap, Object.values(IsSapActiveFilterValue)],
  [ShipmentFilterName.EtaUpdateInSap, Object.values(IsSapActiveFilterValue)],
  [ShipmentFilterName.CriticalTransitLocations, Object.values(ShipmentCriticalTransitLocations)],
  [ShipmentFilterName.CriticalTransitStatuses, Object.values(ShipmentCriticalTransitStatuses)],
]);

export enum DemurrageDetentionStatisticFilterKeysEnum {
  ContainerCharges = 'containerCharges',
}

export class DemurrageDetentionStatisticFilterModel {
  [DemurrageDetentionStatisticFilterKeysEnum.ContainerCharges]: string | null = null;
}

export class DemurrageDetentionStatisticFilterForm {
  constructor(
    model: DemurrageDetentionStatisticFilterModel,
    fb: FormBuilder = new FormBuilder(),
    public containerCharges: FormControl<string> = fb.control<string>(model.containerCharges, []),
  ) {}
}

export class StatisticFilterModel {
  [StatisticFilterKeysEnum.Milestone]: string | null = null;
  [StatisticFilterKeysEnum.Deviation]: string | null;
  [StatisticFilterKeysEnum.Info]: string | null = null;
}

export class StatisticFilterForm {
  constructor(
    model: StatisticFilterModel,
    fb: FormBuilder = new FormBuilder(),
    public milestone: FormControl<string> = fb.control<string>(model.milestone, []),
    public deviation: FormControl<string> = fb.control<string>(model.deviation, []),
    public info: FormControl<string> = fb.control<string>(model.info, []),
  ) {}
}

export class ShipmentFilterBaseModel {
  [ShipmentFilterName.TransportModes]: TransportMode[] = [];
  [ShipmentFilterName.Statuses]: ShipmentMonitoringStatus[] = [];
  [ShipmentFilterName.Origins]: Origin[] = [];
  [ShipmentFilterName.Carriers]: string[] = [];
  [ShipmentFilterName.Pickups]: string[] = [];
  [ShipmentFilterName.ShipTos]: string[] = [];
  [ShipmentFilterName.DeliveryServices]: DeliveryService[] = [];
  [ShipmentFilterName.TransportOrderNumbers]: string[] = [];
  [ShipmentFilterName.SapPlantIds]: string[] = [];
  [ShipmentFilterName.SapSupplierNumbers]: string[] = [];
  [ShipmentFilterName.SapSupplierNames]: string[] = [];
  [ShipmentFilterName.SapMrpControllers]: string[] = [];
  [ShipmentFilterName.SapMaterialNumbers]: string[] = [];
  [ShipmentFilterName.SapDeliveryNumbers]: string[] = [];
  [ShipmentFilterName.SapPoNumbers]: string[] = [];
  [ShipmentFilterName.SapExternalDeliveryNumbers]: string[] = [];
  [ShipmentFilterName.LoadNumbers]: string[] = [];
  [ShipmentFilterName.MaterialNumbers]: string[] = [];
  [ShipmentFilterName.IStarNumbers]: string[] = [];
  [ShipmentFilterName.Consignees]: string[] = [];
  [ShipmentFilterName.DeliveryNoteNumbers]: string[] = [];
  [ShipmentFilterName.ReasonCodes]: string[] = [];
  [ShipmentFilterName.StatusCodes]: string[] = [];
  [ShipmentFilterName.CarrierTOs]: string[] = [];
  [ShipmentFilterName.CommercialInvoiceNumbers]: string[] = [];
  [ShipmentFilterName.PurchaseOrderNumbers]: string[] = [];
  [ShipmentFilterName.TruckPlates]: string[] = [];
  [ShipmentFilterName.TrailerPlates]: string[] = [];
  [ShipmentFilterName.FlightNumbers]: string[] = [];
  [ShipmentFilterName.VesselNames]: string[] = [];
  [ShipmentFilterName.DeviationTypes]: DeviationType[] = [];
  [ShipmentFilterName.DeviationHours]: number = null;
  [ShipmentFilterName.EquipmentIds]: string[] = [];
  [ShipmentFilterName.Waybills]: string[] = [];
  [ShipmentFilterName.References]: string[] = [];
  [ShipmentFilterName.MRPControllers]: string[] = [];
  [ShipmentFilterName.BusinessUnits]: string[] = [];
  [ShipmentFilterName.InboundPlants]: string[] = [];
  [ShipmentFilterName.ShipToPlants]: MonitoringFilterGateOption[] = [];
  [ShipmentFilterName.ConsigneePlants]: MonitoringFilterPlantOption[] = [];
  [ShipmentFilterName.InboundRegions]: ShipmentListFiltersRegions[] = [];
  [ShipmentFilterName.OutboundRegions]: ShipmentListFiltersRegions[] = [];
  [ShipmentFilterName.NetworkParts]: string[] = [];
  [ShipmentFilterName.ConsignorAddresses]: string[] = [];
  [ShipmentFilterName.FreightPayers]: string[] = [];
  [ShipmentFilterName.ContractIdentifiers]: string[] = [];
  [ShipmentFilterName.RbPoNumbers]: string[] = [];
  [ShipmentFilterName.UnNumbers]: string[] = [];
  [ShipmentFilterName.RouteIds]: string[] = [];
  [ShipmentFilterName.BarcodeIds]: string[] = [];
  [ShipmentFilterName.BoschOrderNumbers]: string[] = [];
  [ShipmentFilterName.CustomerOrderNumbers]: string[] = [];
  [ShipmentFilterName.BoschMaterialNumbers]: string[] = [];
  [ShipmentFilterName.CustomerMaterialNumbers]: string[] = [];
  [ShipmentFilterName.SapIds]: { id: string; selected: boolean }[] = [];
  [ShipmentFilterName.HUIds]: string[] = [];
  [ShipmentFilterName.ServiceTypes]: string[] = [];
  [ShipmentFilterName.SecondaryEtaSources]: string[] = [];
  [ShipmentFilterName.SourceCountries]: string[] = [];
  [ShipmentFilterName.DestinationCountries]: string[] = [];
  [ShipmentFilterName.SourceLocations]: string[] = [];
  [ShipmentFilterName.DestinationLocations]: string[] = [];
  [ShipmentFilterName.PortsOfLoading]: { abbreviation: string; cityName: string }[] = [];
  [ShipmentFilterName.PortsOfDischarge]: { abbreviation: string; cityName: string }[] = [];
  [ShipmentFilterName.PortsOfLoadingCountries]: string[] = [];
  [ShipmentFilterName.PortsOfDischargeCountries]: string[] = [];
  [ShipmentFilterName.PortsOfLoadingRegions]: string[] = [];
  [ShipmentFilterName.PortsOfDischargeRegions]: string[] = [];
  [ShipmentFilterName.EtaTransferInSap]: boolean | null = null;
  [ShipmentFilterName.EtaUpdateInSap]: boolean | null = null;
  [ShipmentFilterName.SapSystems]: string[] = [];
  [ShipmentFilterName.CriticalTransitLocations]: string | null = null;
  [ShipmentFilterName.CriticalTransitStatuses]: string | null = null;

  constructor(params?: ShipmentFilterBaseModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ShipmentFiltersDatepickerRangeModel extends ShipmentFilterBaseModel {
  [ShipmentFilterName.EstimatedDepartureTimeLoad] = new DatepickerRangeModel();
  [ShipmentFilterName.EstimatedDepartureTimeTOAndWaybill] = new DatepickerRangeModel();
  [ShipmentFilterName.ActualDepartureTimeLoad] = new DatepickerRangeModel();
  [ShipmentFilterName.ActualDepartureTimeTOAndWaybill] = new DatepickerRangeModel();
  [ShipmentFilterName.PlannedDepartureTimeLoad] = new DatepickerRangeModel();
  [ShipmentFilterName.PlannedDepartureTimeTOAndWaybill] = new DatepickerRangeModel();
  [ShipmentFilterName.ArrivalTime] = new CombinedDatepickerRangeModel();
  [ShipmentFilterName.DepartureTime] = new CombinedDatepickerRangeModel();

  constructor(params?: ShipmentFiltersDatepickerRangeModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ShipmentFiltersDatepickerRangeOutput extends ShipmentFilterBaseModel {
  [ShipmentFilterName.EstimatedDepartureTimeLoad] = new DatepickerRangeOutput();
  [ShipmentFilterName.EstimatedDepartureTimeTOAndWaybill] = new DatepickerRangeOutput();
  [ShipmentFilterName.ActualDepartureTimeLoad] = new DatepickerRangeOutput();
  [ShipmentFilterName.ActualDepartureTimeTOAndWaybill] = new DatepickerRangeOutput();
  [ShipmentFilterName.PlannedDepartureTimeLoad] = new DatepickerRangeOutput();
  [ShipmentFilterName.PlannedDepartureTimeTOAndWaybill] = new DatepickerRangeOutput();
  [ShipmentFilterName.ArrivalTime] = new CombinedDatepickerRangeOutput();
  [ShipmentFilterName.DepartureTime] = new CombinedDatepickerRangeOutput();

  constructor(params?: ShipmentFiltersDatepickerRangeOutput) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ShipmentFilterForm {
  constructor(
    model: ShipmentFiltersDatepickerRangeModel,
    fb: FormBuilder = new FormBuilder(),
    public transportModes: FormControl<TransportMode[]> = fb.control<TransportMode[]>(model.transportModes, []),
    public departureTime: FormControl<CombinedDatepickerRangeOutput> = fb.control<CombinedDatepickerRangeOutput>(
      new CombinedDatepickerRangeOutput(model.departureTime),
      [],
    ),
    public deviationTypes: FormControl<DeviationType[]> = fb.control<DeviationType[]>(model.deviationTypes, []),
    public deviationHours: FormControl<number> = fb.control<number>(model.deviationHours, [
      Validators.pattern(NUMBER_PATTERN),
    ]),
    public statuses: FormControl<ShipmentMonitoringStatus[]> = fb.control<ShipmentMonitoringStatus[]>(
      model.statuses,
      [],
    ),
    public origins: FormControl<Origin[]> = fb.control<Origin[]>(model.origins, []),
    public deliveryServices: FormControl<DeliveryService[]> = fb.control<DeliveryService[]>(model.deliveryServices, []),
    public transportOrderNumbers: FormControl<string[]> = fb.control<string[]>(model.transportOrderNumbers, []),
    public sapPlantIds: FormControl<string[]> = fb.control<string[]>(model.sapPlantIds, []),
    public sapSupplierNumbers: FormControl<string[]> = fb.control<string[]>(model.sapSupplierNumbers, []),
    public sapSupplierNames: FormControl<string[]> = fb.control<string[]>(model.sapSupplierNames, []),
    public sapMrpControllers: FormControl<string[]> = fb.control<string[]>(model.sapMrpControllers, []),
    public sapMaterialNumbers: FormControl<string[]> = fb.control<string[]>(model.sapMaterialNumbers, []),
    public sapDeliveryNumbers: FormControl<string[]> = fb.control<string[]>(model.sapDeliveryNumbers, []),
    public sapPoNumbers: FormControl<string[]> = fb.control<string[]>(model.sapPoNumbers, []),
    public sapExternalDeliveryNumbers: FormControl<string[]> = fb.control<string[]>(
      model.sapExternalDeliveryNumbers,
      [],
    ),
    public loadNumbers: FormControl<string[]> = fb.control<string[]>(model.loadNumbers, []),
    public materialNumbers: FormControl<string[]> = fb.control<string[]>(model.materialNumbers, []),
    public iStarNumbers: FormControl<string[]> = fb.control<string[]>(model[ShipmentFilterName.IStarNumbers], []),
    public deliveryNoteNumbers: FormControl<string[]> = fb.control<string[]>(model.deliveryNoteNumbers, []),
    public reasonCodes: FormControl<string[]> = fb.control<string[]>(model.reasonCodes, []),
    public statusCodes: FormControl<string[]> = fb.control<string[]>(model.statusCodes, []),
    public carrierTOs: FormControl<string[]> = fb.control<string[]>(model.carrierTOs, []),
    public commercialInvoiceNumbers: FormControl<string[]> = fb.control<string[]>(model.commercialInvoiceNumbers, []),
    public purchaseOrderNumbers: FormControl<string[]> = fb.control<string[]>(model.purchaseOrderNumbers, []),
    public truckPlates: FormControl<string[]> = fb.control<string[]>(model.truckPlates, []),
    public trailerPlates: FormControl<string[]> = fb.control<string[]>(model.trailerPlates, []),
    public flightNumbers: FormControl<string[]> = fb.control<string[]>(model.flightNumbers, []),
    public vesselNames: FormControl<string[]> = fb.control<string[]>(model.vesselNames, []),
    public equipmentIds: FormControl<string[]> = fb.control<string[]>(model.equipmentIds, []),
    public carriers: FormControl<string[]> = fb.control<string[]>(model.carriers, []),
    public shipTos: FormControl<string[]> = fb.control<string[]>(model.shipTos, []),
    public pickups: FormControl<string[]> = fb.control<string[]>(model.pickups, []),
    public consignees: FormControl<string[]> = fb.control<string[]>(model.consignees, []),
    public waybills: FormControl<string[]> = fb.control<string[]>(model.waybills, []),
    public references: FormControl<string[]> = fb.control<string[]>(model.references, []),
    public mrpControllers: FormControl<string[]> = fb.control<string[]>(model.mrpControllers, []),
    public businessUnits: FormControl<string[]> = fb.control<string[]>(model.businessUnits, []),
    public inboundPlants: FormControl<string[]> = fb.control<string[]>(model.inboundPlants, []),
    public shipToPlants: FormControl<MonitoringFilterGateOption[]> = fb.control<MonitoringFilterGateOption[]>(
      model.shipToPlants,
      [],
    ),
    public consigneePlants: FormControl<MonitoringFilterPlantOption[]> = fb.control<MonitoringFilterPlantOption[]>(
      model.consigneePlants,
      [],
    ),
    public estimatedDepartureTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.estimatedDepartureTimeLoad),
      [],
    ),
    public actualDepartureTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.actualDepartureTimeLoad),
      [],
    ),
    public plannedDepartureTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.plannedDepartureTimeLoad),
      [],
    ),
    public estimatedDepartureTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.estimatedDepartureTimeTOAndWaybill),
      [],
    ),
    public actualDepartureTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.actualDepartureTimeTOAndWaybill),
      [],
    ),
    public plannedDepartureTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.plannedDepartureTimeTOAndWaybill),
      [],
    ),
    public arrivalTime: FormControl<CombinedDatepickerRangeOutput> = fb.control<CombinedDatepickerRangeOutput>(
      new CombinedDatepickerRangeOutput(model.arrivalTime),
      [],
    ),
    public inboundRegions: FormControl<ShipmentListFiltersRegions[]> = fb.control<ShipmentListFiltersRegions[]>([], []),
    public outboundRegions: FormControl<ShipmentListFiltersRegions[]> = fb.control<ShipmentListFiltersRegions[]>(
      [],
      [],
    ),
    public networkParts: FormControl<string[]> = fb.control<string[]>(model.networkParts, []),
    public consignorAddresses: FormControl<string[]> = fb.control<string[]>(model.consignorAddresses, []),
    public freightPayers: FormControl<string[]> = fb.control<string[]>(model.freightPayers, []),
    public contractIdentifiers: FormControl<string[]> = fb.control<string[]>(model.contractIdentifiers, []),
    public rbPoNumbers: FormControl<string[]> = fb.control<string[]>(model.rbPoNumbers, []),
    public unNumbers: FormControl<string[]> = fb.control<string[]>(model.unNumbers, []),
    public routeIds: FormControl<string[]> = fb.control<string[]>(model.routeIds, []),
    public barcodeIds: FormControl<string[]> = fb.control<string[]>(model.barcodeIds, []),
    public boschOrderNumbers: FormControl<string[]> = fb.control<string[]>(model.boschOrderNumbers, []),
    public customerOrderNumbers: FormControl<string[]> = fb.control<string[]>(model.customerOrderNumbers, []),
    public boschMaterialNumbers: FormControl<string[]> = fb.control<string[]>(model.boschMaterialNumbers, []),
    public customerMaterialNumbers: FormControl<string[]> = fb.control<string[]>(model.customerMaterialNumbers, []),
    public sapIds: FormControl<{ id: string; selected: boolean }[]> = fb.control<{ id: string; selected: boolean }[]>(
      model.sapIds,
      [],
    ),
    public huIds: FormControl<string[]> = fb.control<string[]>(model.huIds, []),
    public serviceTypes: FormControl<string[]> = fb.control<string[]>(model.serviceTypes, []),
    public secondaryEtaSources: FormControl<string[]> = fb.control<string[]>(model.secondaryEtaSources, []),
    public sourceCountries: FormControl<string[]> = fb.control<string[]>(model.sourceCountries, []),
    public destinationCountries: FormControl<string[]> = fb.control<string[]>(model.destinationCountries, []),
    public sourceLocations: FormControl<string[]> = fb.control<string[]>(model.sourceLocations, []),
    public destinationLocations: FormControl<string[]> = fb.control<string[]>(model.destinationLocations, []),
    public portsOfLoading: FormControl<{ abbreviation: string; cityName: string }[]> = fb.control<
      { abbreviation: string; cityName: string }[]
    >(model.portsOfLoading, []),
    public portsOfDischarge: FormControl<{ abbreviation: string; cityName: string }[]> = fb.control<
      { abbreviation: string; cityName: string }[]
    >(model.portsOfDischarge, []),
    public portsOfLoadingCountries: FormControl<string[]> = fb.control<string[]>(model.portsOfLoadingCountries, []),
    public portsOfDischargeCountries: FormControl<string[]> = fb.control<string[]>(model.portsOfDischargeCountries, []),
    public portsOfLoadingRegions: FormControl<string[]> = fb.control<string[]>(model.portsOfLoadingRegions, []),
    public portsOfDischargeRegions: FormControl<string[]> = fb.control<string[]>(model.portsOfDischargeRegions, []),
    public etaTransferInSap: FormControl<boolean> = fb.control<boolean>(model.etaTransferInSap, []),
    public etaUpdateInSap: FormControl<boolean> = fb.control<boolean>(model.etaUpdateInSap, []),
    public sapSystems: FormControl<string[]> = fb.control<string[]>(model.sapSystems, []),
    public criticalTransitLocations: FormControl<string> = fb.control<string>(model.criticalTransitLocations, []),
    public criticalTransitStatuses: FormControl<string> = fb.control<string>(model.criticalTransitStatuses, []),
  ) {}
}

export class ShipmentFiltersGeneralFormModel {
  viewMode?: ListViewMode = ListViewMode.TransportOrder;
  materialView?: boolean = false;
  shipmentStatisticFilter?: StatisticFilterModel = {
    milestone: null,
    deviation: null,
    info: null,
  };
  dndStatisticFilter?: DemurrageDetentionStatisticFilterModel = {
    containerCharges: null,
  };
  filters: ShipmentFiltersDatepickerRangeModel = new ShipmentFiltersDatepickerRangeModel();
}

export class ShipmentFiltersGeneralForm {
  constructor(
    model: ShipmentFiltersGeneralFormModel,
    fb: FormBuilder = new FormBuilder(),
    public viewMode: FormControl<ListViewMode> = fb.control<ListViewMode>(model.viewMode, []),
    public materialView: FormControl<boolean> = fb.control<boolean>(model.materialView, []),
    public shipmentStatisticFilter: FormGroup<StatisticFilterForm> = fb.group<StatisticFilterForm>(
      new StatisticFilterForm(model.shipmentStatisticFilter),
    ),
    public dndStatisticFilter: FormGroup<DemurrageDetentionStatisticFilterForm> = fb.group<DemurrageDetentionStatisticFilterForm>(
      new DemurrageDetentionStatisticFilterForm(model.dndStatisticFilter),
    ),
    public filters: FormGroup<ShipmentFilterForm> = fb.group<ShipmentFilterForm>(new ShipmentFilterForm(model.filters)),
  ) {}
}

export class ShipmentPlannerProfileFilterModel extends ShipmentFiltersDatepickerRangeOutput {
  constructor(params?: ShipmentPlannerProfileFilterModel) {
    super();

    if (params) {
      const shipToPlants: MonitoringFilterGateOption[] = (params?.shipToPlants ?? []).map(
        (option: MonitoringFilterGateOption) => new MonitoringFilterGateOption(option),
      );
      const consigneePlants: MonitoringFilterPlantOption[] = (params?.consigneePlants ?? []).map(
        (option: MonitoringFilterPlantOption) => new MonitoringFilterPlantOption(option),
      );
      const newParamsWithPlants = { ...params, shipToPlants, consigneePlants };

      assignObjectIfPropertyValueValid(this, newParamsWithPlants);
    }
  }
}
